import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import { convertArrToObj } from 'lib/src/utils/generic';
import {
    fetchAllContactUsMessagesRequest,
    fetchAllContactUsMessagesSuccess,
    fetchAllContactUsMessagesFailure,
    fetchSingleContactUsMessageRequest,
    fetchSingleContactUsMessageSuccess,
    fetchSingleContactUsMessageFailure,
    deleteContactUsMessageRequest,
    deleteContactUsMessageSuccess,
    deleteContactUsMessageFailure,
} from '@actions/contactUsMessages';
import { ContactUsMessage } from 'src/types/shared/ContactUsMessages';

interface ContactUsMessagesState {
    isFetching: boolean;
    isDeleting: boolean;
    fetchError: string | null;
    deleteError: string | null;
    contactUsMessages: { [key: number]: ContactUsMessage };
}

const initialState: ContactUsMessagesState = {
    isFetching: false,
    isDeleting: false,
    fetchError: null,
    deleteError: null,
    contactUsMessages: {},
};

export default createReducer(initialState, {
    [fetchAllContactUsMessagesRequest.type]: handleFetchRequest,
    [fetchAllContactUsMessagesSuccess.type]: handleFetchAllContactUsMessagesSuccess,
    [fetchAllContactUsMessagesFailure.type]: handleFetchError,
    [fetchSingleContactUsMessageRequest.type]: handleFetchRequest,
    [fetchSingleContactUsMessageSuccess.type]: handleFetchSingleContactUsMessageSuccess,
    [fetchSingleContactUsMessageFailure.type]: handleFetchError,
    [deleteContactUsMessageRequest.type]: handleDeleteRequest,
    [deleteContactUsMessageSuccess.type]: handleDeleteContactUsMessageSuccess,
    [deleteContactUsMessageFailure.type]: handleDeleteFailure,
});

function handleFetchRequest(state: ContactUsMessagesState) {
    state.isFetching = true;
    state.fetchError = null;
}
function handleFetchError(state: ContactUsMessagesState, action: PayloadAction<string>) {
    state.fetchError = action.payload;
    state.isFetching = false;
}
function handleDeleteRequest(state: ContactUsMessagesState) {
    state.isDeleting = true;
    state.deleteError = null;
}
function handleDeleteFailure(state: ContactUsMessagesState, action: PayloadAction<string>) {
    state.deleteError = action.payload;
    state.isDeleting = false;
}

function handleFetchAllContactUsMessagesSuccess(
    state: ContactUsMessagesState,
    action: PayloadAction<ContactUsMessage[]>,
) {
    state.contactUsMessages = convertArrToObj(action.payload);
    state.isFetching = false;
}

function handleFetchSingleContactUsMessageSuccess(
    state: ContactUsMessagesState,
    action: PayloadAction<ContactUsMessage>,
) {
    state.contactUsMessages[action.payload.id] = action.payload;
    state.isFetching = false;
}

function handleDeleteContactUsMessageSuccess(
    state: ContactUsMessagesState,
    action: PayloadAction<number>,
) {
    state.isDeleting = false;
    delete state.contactUsMessages[action.payload];
}
